// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventGuestEntity from './entities/event-guest.json';
import eventGuestMenu from '../pages/event-guest/menu.json';
import eventGuestFullForm from '../pages/event-guest/forms/full.json';
import eventGuestContextForm from '../pages/event-guest/forms/context.json';
import eventGuestMiniForm from '../pages/event-guest/forms/mini.json';
import eventGuestLookupForm from '../pages/event-guest/forms/lookup.json';
import eventGuestTableView from '../pages/event-guest/views/table.json';
import eventGuestCardsView from '../pages/event-guest/views/cards.json';
import eventGuestDashboardView from '../pages/event-guest/views/dashboard.json';

/** Тип запису «Гість» зі сторінками пакета: меню, форми та подання з pages/event-guest/. */
export const eventGuestDefinition: IRecordTypeDefinition = {
  ...eventGuestEntity,
  views: assembleViewSet({
      table: eventGuestTableView,
      cards: eventGuestCardsView,
      dashboard: eventGuestDashboardView,
  }),
  form: eventGuestFullForm,
  forms: { full: eventGuestFullForm, context: eventGuestContextForm, mini: eventGuestMiniForm, lookup: eventGuestLookupForm },
  menu: eventGuestMenu,
} as IRecordTypeDefinition;
